module.exports = __webpack_public_path__ + "static/parade-2019-house10-ed6adb65e80cf654d4f4c9643cb7081a.jpg";